export default __webpack_public_path__ + "static/media/img_1@3x.391fccf9.png";